'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useSetKeyboardNavigation", {
    enumerable: true,
    get: function() {
        return useSetKeyboardNavigation;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useKeyborgRef = require("./useKeyborgRef");
function useSetKeyboardNavigation() {
    const keyborgRef = (0, _useKeyborgRef.useKeyborgRef)();
    return _react.useCallback((isNavigatingWithKeyboard)=>{
        var _keyborgRef_current;
        (_keyborgRef_current = keyborgRef.current) === null || _keyborgRef_current === void 0 ? void 0 : _keyborgRef_current.setVal(isNavigatingWithKeyboard);
    }, [
        keyborgRef
    ]);
}
